import { render, staticRenderFns } from "./SetupDetail.vue?vue&type=template&id=bd57e47e&"
import script from "./SetupDetail.vue?vue&type=script&lang=js&"
export * from "./SetupDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports